module.exports = __webpack_public_path__ + "static/media/step-1.d3d84dfb.gif";